<template>
    <div class="stepDetail">
        <div class="con content_first" style="padding:.15rem .12rem 0.1rem;">
            <div @click="setShow=true">
                <div class="to_dailog_div">设置步数 <van-icon name="arrow" /></div>
            </div>
            <div class="first_chart" >
                <solid-chart :value="Number(alreadyStep)/Number(maxStep)*100" :maxStep="maxStep" :alreadyStep="alreadyStep"/>
            </div>
            <div class="first_green" v-if="maxStep<=alreadyStep"><van-icon name="checked" />&nbsp;已达成目标真棒!</div>
            <div class="first_blue" v-else><van-icon name="info" />&nbsp;距离达成目标还差{{maxStep-alreadyStep}}步</div>
            <!-- <div class="first_foot">宝贝今日步行{{stepInfo.distance}}公里，相当于走了{{stepInfo.circle}}圈标准操场，每天保持一定的步数有助于宝贝的身体健康哦。</div> -->
        </div>
        <van-popup v-model="setShow" position="bottom">
            <p class="gray font14 note">根据世界卫生组织的建议，每天需要进行中等强度的运动40分钟，相当于快走7000步。</p>
            <van-picker title="设置步数"  show-toolbar @confirm="onConfirm" @cancel="setShow=false" :columns="columns"></van-picker>
        </van-popup>
        <div class="mid_title">最佳纪录</div>
        <div class="con content_scond" style="padding:.15rem .12rem 0.1rem;">
            <div class="scond_title">
                <div class="title_left">单日最高纪录</div>
                <div class="title_right">{{stepInfo.bestStepDate}}</div>
            </div>
            <div>
                <span class="content_left">{{stepInfo.bestStepNum}}</span>
                <span class="content_right">步</span>
            </div>
        </div>
        <div class="mid_title">排行榜</div>
        <div class="con content_third" style="padding:.15rem .12rem 0.1rem;">
            <div class="third_top">今日班级步数排行榜</div>
            <div>
                <span class="third_top">第</span>
                <span class="third_top" style="color: #FFE485;font-size: 0.24rem;margin: 0 0.05rem;">{{stepInfo.classRanking?stepInfo.classRanking:'--'}}</span>
                <span class="third_top">名</span>
            </div>
            <div class="third_bottom">
                <div>今日全校步数排行榜</div>
                <div>第{{stepInfo.schoolRanking?stepInfo.schoolRanking:'--'}}名</div>
            </div>
        </div>
        <div class="mid_title">运动详情</div>
        <div class="con" style="padding:.15rem .05rem 0.1rem;">
            <van-radio-group v-model="valueType" direction="horizontal">
                <van-radio name="1" :checked-icon="false" :unchecked-icon="false">日</van-radio>
                <van-radio name="2" :checked-icon="false" :unchecked-icon="false">周</van-radio>
                <van-radio name="3" :checked-icon="false" :unchecked-icon="false">月</van-radio>
                <van-radio name="4" :checked-icon="false" :unchecked-icon="false">年</van-radio>
            </van-radio-group>
            <!-- <div class="tab flex-center"><p :class='{active:cur==1}' @click="getChart(1)">日</p><p :class='{active1:cur==2}' @click="getChart(2)">月</p></div> -->
            <scroll-chart :valueType="valueType" ref="scrollRef"  />
        </div>
    </div>
</template>
<script>
import {getStudentStepDetail,setStudentStep} from "@/api/api.report";
import scrollChart from './components/scrollChart.vue';
import solidChart from './components/solidChart.vue';
import '@/assets/css/radiio.scss'
export default {
  data() {
    return {
        chartData:[],
        categories:[],
        stepInfo:{},
        maxStep:0,
        alreadyStep:0,
        columns: ['2000', '3000', '4000', '5000', '6000', '7000', '8000', '9000','10000', '11000', '12000', '13000', '14000', '15000', '16000', '17000',"18000",'19000','20000'],
        valueType:"1",
        setShow:false
    }
  },
  components:{scrollChart,solidChart},
  created(){
   this.getStudentStepInfo()
  },
  methods: {
    getStudentStepInfo(){
        getStudentStepDetail({studentId:this.loginUser.studentId}).then((res)=>{
            this.stepInfo=res.result
            this.alreadyStep=res.result.stepNum
            this.maxStep=res.result.targetStep
        })
    },
    onConfirm(val) {
        setStudentStep({studentId:this.loginUser.studentId,targetStep:Number(val)}).then(()=>{
            this.maxStep=Number(val) 
            this.setShow=false
        })
        
    },
    onClickLeft(){}
  },
}
</script>
<style lang="scss" >
    .stepDetail{
        padding:0rem .12rem .12rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        .note{
            position: absolute;
            top: 0.42rem;
            z-index: 2;
            background: #fff;
            padding: 0px 0.12rem;
        }
        .con{
            margin-top: .13rem;
            background:#fff;
            border-radius: 12px;
            padding:.12rem .12rem;
        }
        .mid_title{
            font-size: 0.16rem;
            font-weight: 600;
            color: #333333;
            margin-top: 0.12rem;
        }
        .content_first{
            height: 2rem;
            position: relative;
            background-image: url(../../assets/img/step/first.png);
            background-size: 100%;
            .to_dailog_div{
                position: absolute;
                right: 0.12rem;
                z-index: 1;
            }
            .first_chart{
            }
            .first_green{
                color: #00CD90;
                position: absolute;
                bottom: 0.45rem;
                left: 1.22rem;
                font-weight: 600;
            }
            .first_blue{
                position: absolute;
                bottom: 0.33rem;
                left: 1rem;
                color: #0075FF;
                font-weight: 600;

            }
            .first_foot{
                position: absolute;
                bottom: .12rem;
                font-size: 0.1rem;
                color: #022C5E;
                line-height: 0.12rem;
            }
        }
        .content_scond{
            height: 1rem;
            background-image: url(../../assets/img/step/scond.png);
            background-size: 100%;
            .scond_title{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title_left{
                    font-size: 0.14rem;
                    
                    font-weight: 400;
                    color: #966220;
                }
                .title_right{
                    font-size: 0.10rem;
                    font-weight: 400;
                    color: #A6722B;
                }
                
            }
            .content_left{
                font-size: 0.24rem;
                font-weight: 500;
                color: #975C0F;
                margin-right: 0.1rem;
            }
            .content_right{
                font-size: 0.1rem;
                font-weight: 400;
                color: #A6722C;
            }
        }
        .content_third{
            height: 1.42rem;
            background-image: url(../../assets/img/step/third.png);
            background-size: 100%;
            .third_top{
                font-size: 0.14rem;
                font-weight: 400;
                color: #FFFFFF;
            }
            
            .third_bottom{
                height: 0.4rem;
                background: rgba(255,255,255,0.63);
                border-radius: 0.08rem;
                opacity: 1;
                margin-top: 0.3rem; 
                display: flex;
                justify-content: space-between;
                align-items: center;       
                color: #032B7A;
                font-size: 0.12rem; 
                padding: 0 0.08rem;       
            }
        }
    }
</style>